// combatpro/damage/damageTypes.js
//
// Stage 76 (Resistance View): the canonical React copy of the legacy damage-type
// list consumed by the standalone resistance calculator. Ported verbatim from
// the calcDamageType-${index} <select> options (battletracker.html 6339-6350,
// 12 entries, in source order). The legacy page had no DAMAGE_TYPES constant -
// the list was inline option markup - so this becomes the single canonical
// source, mirroring the effects/effectsDb.js pattern.
//
// PURE DATA: no React, no hooks, no context, no DOM, no window, no runtime
// ownership, no side effects. Display strings double as the values (legacy used
// value === label for every option). The resistance calculator lower-cases for
// matching, exactly as legacy did.

export const DAMAGE_TYPES = [
  "Slashing",
  "Piercing",
  "Bludgeoning",
  "Fire",
  "Cold",
  "Lightning",
  "Thunder",
  "Acid",
  "Poison",
  "Necrotic",
  "Radiant",
  "Force"
];
